export const WebAppState = {
  None: 'None',
  WebAppSmsSent: 'WebAppSmsSent',
  LocationSmsSent: 'LocationSmsSent',
  AppOpened: 'AppOpened',
  LocationPermissionRequested: 'LocationPermissionRequested',
  LocationPermissionGranted: 'LocationPermissionGranted',
  LocationUnavailableNotSupported: 'LocationUnavailableNotSupported',
  LocationPermissionDenied: 'LocationPermissionDenied',
  LocationPositionUnavailable: 'LocationPositionUnavailable',
  LocationTimeout: 'LocationTimeout',
  CameraPermissionRequested: 'CameraPermissionRequested',
  CameraPermissionGranted: 'CameraPermissionGranted',
  CameraPermissionRejected: 'CameraPermissionRejected',
  UnsupportedBrowser: 'UnsupportedBrowser',
  StartingVideoTransmission: 'StartingVideoTransmission',
  VideoTransmissionActive: 'VideoTransmissionActive',
  VideoTransmissionFailed: 'VideoTransmissionFailed',
} as const;

export type WebAppState = (typeof WebAppState)[keyof typeof WebAppState];
